import { createApp } from 'vue'
import styles from './search/search.scss'
import ChatTab from './search/chat_tab.vue'

const safeRegisterElement = (name, element, options = {}) => !window.customElements.get(name) && window.customElements.define(name, element, options)

safeRegisterElement('docuseal-chat', class extends HTMLElement {
  connectedCallback () {
    const shadow = this.attachShadow({ mode: 'open' })
    const style = document.createElement('style')

    style.textContent = styles[0][1].replace(/:root/g, ':host').replace(/html {/g, '.ds {')

    this.appElem = document.createElement('div')
    this.appElem.classList.add('ds')
    this.style.display = 'block'

    shadow.appendChild(style)

    this.app = createApp(ChatTab, { withSharedChat: true, messagesContainerStyle: { maxHeight: 'calc(100vh - 20rem)' } })

    if (process.env.NODE_ENV === 'development') {
      this.app.provide('baseUrl', 'http://localhost:3001/search')
      this.app.provide('websiteUrl', 'http://localhost:3001')
    } else {
      this.app.provide('baseUrl', 'https://search.docuseal.com')
      this.app.provide('websiteUrl', 'https://www.docuseal.com')
    }

    this.vm = this.app.mount(this.appElem)

    shadow.appendChild(this.appElem)
  }
})
